import { getEnv } from './env';

const CLIENTSPACE_DOMAIN = 'clientspace.net';

/**
 * ClientSpace subdomain is environment-scoped: production talks to the real
 * tenant, everything else (qa/dev/local) talks to the QA tenant. Same split
 * used by the existing ClientServiceCase link in CaseFormDialog.
 */
export function getClientSpaceSubdomain(): string {
  return getEnv('VITE_ENVIRONMENT') === 'production' ? 'gna' : 'gnaqa';
}

/**
 * Build the ClientSpace workspace deep-link, or null when no workspace id is
 * available so callers can hide the link entirely.
 */
export function getClientSpaceWorkspaceUrl(
  workspaceId: string | number | null | undefined
): string | null {
  const id =
    workspaceId == null || workspaceId === '' ? '' : String(workspaceId).trim();
  if (!id) return null;

  return `https://${getClientSpaceSubdomain()}.${CLIENTSPACE_DOMAIN}/next/linkto/workspace/${id}`;
}
